// extracted by mini-css-extract-plugin
export default {"tableBox":"tableBox-nD45km","selectAllTips":"selectAllTips-IZPsHz","btn":"btn-df8yA6"};